'use client';

import { DataLayerPageTypeEnum } from '@nocowanie/core/models';

import { usePageDataLayerEvents } from '@app/hooks/usePageDataLayerEvents';
import { usePagePath } from '@app/hooks/usePagePath';

/**
 * Renders nothing; sends the page view dataLayer events.
 * Kept as its own component so user profile / `isPageDataLayerSent` updates after load
 * re-render only this component instead of the whole page that would host the hook.
 */
export const PageDataLayerEvents = ({ pageType }: { pageType: DataLayerPageTypeEnum }) => {
    const pagePath = usePagePath();

    usePageDataLayerEvents({ pageType, pagePath });

    return null;
};
